import React from 'react';
import { Typography } from 'components/ui-lib';
import useStyles from './styles';
import logoSrc from './assets/logo.png';

export default function Loader() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.loader}>
        <div className={classes.pacman}/>
        <div className={classes.bols}>
          <div/>
          <div/>
          <div/>
        </div>
        <img src={logoSrc} alt="dtek" className={classes.logo}/>
        <Typography variant="body2" className={classes.text}>
          Почекайте, йде завантаження
        </Typography>
      </div>
    </div>
  );
}
